import { Box, Flex, Heading, Text } from "@chakra-ui/react"
import * as React from "react"
import { Image } from "../image"
import YouTube from "../video/YoutubeEmbed"
import MojoListIcon from "../icons/MojoListIcon"
import { usePurchasingCTAs } from "../form/usePurchasingCTAs"

export function MojoList({
	title,
	pageType,
	paragraphs,
	bulletPoints,
	imageArray,
	youtubeId,
}) {
	const { titleBg, titleColor, global } = usePurchasingCTAs()
	return (
		<Box>
			<Heading
				display={{
					base: pageType === `products` ? `block` : `none`,
					md: `block`,
				}}
				textTransform="uppercase"
				textAlign={{
					base: pageType === `products` ? `left` : `center`,
					lg: "left",
				}}
				fontSize={{ base: `28px`, md: "30px" }}
				lineHeight="32px"
				fontWeight="600"
				mb={{ base: `0`, lg: `23px` }}
			>
				<Box as="span" bg={titleBg} color={titleColor}>
					{title}
				</Box>
			</Heading>

			{paragraphs?.length > 0 ? (
				<Box display={{ base: `none`, md: `block` }}>
					{paragraphs?.map(({ item }) => {
						return (
							<Box alignSelf="center" mb="30px">
								<Text
									fontSize="18px"
									lineHeight="28px"
									color="black"
									dangerouslySetInnerHTML={{ __html: item }}
								/>
							</Box>
						)
					})}
				</Box>
			) : null}

			{youtubeId && (
				<YouTube
					id={youtubeId}
					opts={{
						height: `274px`,
						width: `100%`,
					}}
				/>
			)}
			{bulletPoints?.length > 0 ? (
				<Box maxW="429px" mb="30px">
					{bulletPoints?.map(({ text }) => {
						return (
							<Flex padding="20px 0 0">
								<Box alignSelf="center">
									<MojoListIcon color={global.checkmark} />
								</Box>
								<Box alignSelf="center">
									<Text
										pl="11px"
										mb="0"
										dangerouslySetInnerHTML={{
											__html: text,
										}}
									/>
								</Box>
							</Flex>
						)
					})}
				</Box>
			) : null}

			{imageArray?.length > 0 ? (
				<Flex>
					{imageArray?.map(({ image }) => {
						if (!image) {
							return null
						}
						return (
							<Box flex="0 0 100%">
								<Box
									maxW="429px"
									minHeight={global.minHeight}
									m={{ base: "0 auto", md: 0 }}
								>
									{image?.localFile?.childImageSharp && (
										<Image
											image={
												image.localFile.childImageSharp
											}
										/>
									)}
								</Box>
							</Box>
						)
					})}
				</Flex>
			) : null}
		</Box>
	)
}
